/**
 * Decorator-free so the frontend can import these without pulling class-validator into
 * the Vite bundle (same reason `prompt-template.constants.ts` exists).
 */

/**
 * Bare hostname: dot-separated labels of letters, digits and hyphens, no leading or
 * trailing hyphen in a label, at least one dot. Matches what PropelAuth expects for
 * an org's email domain (e.g. `acme.com`, `legal.acme.co.uk`).
 */
export const ORGANISATION_DOMAIN_REGEX =
  /^(?=.{1,253}$)([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/;

export const ORGANISATION_NAME_MAX_LENGTH = 200;
